<template>
    <FKBreadCrumb :page="$t('page.create')" :title="$t('page.edit_survey')">
        <FKBreadCrumbItem :page="$t('page.surveys')" to="/surveys" />
    </FKBreadCrumb>
    <SurveyForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import SurveyForm from "@/components/FK/Surveys/Admin/SurveyForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
    name: "UpdateSurveyPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        SurveyForm
    },
});
</script>